<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 12.018c0 .345-.15.672-.407.9l-5.596 4.92a.721.721 0 0 1-.95-1.082l4.322-3.8a.125.125 0 0 0-.082-.218H6.72a.72.72 0 1 1 0-1.44h8.564a.126.126 0 0 0 .083-.219L11.045 7.28a.72.72 0 1 1 .95-1.08l5.597 4.918c.259.228.407.556.408.9Z"
      fill="currentColor"
    />
  </svg>
</template>
